import { init } from './MallCPASSYears';
init();
